import { signIn } from "next-auth/react";
import { DEFAULT_LOGIN_REDIRECT } from "@/routes";
import styles from "@/components/pages/auth/components/styles/provider-button.module.scss";
import TransparentButton from "@/components/common/transparent-button";
import Image from "next/image";
import React from "react";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

type AuthProvider = "google" | "discord";

export interface ThirdPartyButtonProps {
  title: string;
  callbackUrl: string | null;
  isDisabled?: boolean;
}

interface Props extends ThirdPartyButtonProps {
  provider: AuthProvider;
  logo: string | StaticImport;
}

const ThirdPartyServiceButton = ({
  title,
  provider,
  logo,
  callbackUrl,
  isDisabled,
}: Props) => {
  const onClick = () => {
    signIn(provider, { redirectTo: callbackUrl || DEFAULT_LOGIN_REDIRECT });
  };

  return (
    <div className={isDisabled ? styles.disabled : styles.button}>
      <TransparentButton onClick={isDisabled ? undefined : () => onClick()}>
        <Image className={styles.icon} src={logo} alt="logo" />
        {title}
      </TransparentButton>
    </div>
  );
};

export default ThirdPartyServiceButton;
